<template>
  <div class="br-support-survey">
    <div
      :class="{ 'br-support-survey__dialog--success': answered }"
      class="br-support-survey__dialog">
      <p v-if="answered">
        Thank you for helping improve our documentation.
      </p>
      <template v-if="!answered">
        <h2>Was this article helpful?</h2>
        <div class="button-group">
          <button
            class="button u-border-radius"
            @click.prevent="submit('yes')">
            <span class="button__icon"><i class="icon icon-like-2"/></span>
            <span class="button__text">Yes</span>
          </button>
          <button
            class="button u-border-radius"
            @click.prevent="submit('no')">
            <span class="button__icon button__icon--rotate"><i class="icon icon-like-2"/></span>
            <span class="button__text">No</span>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    answered: false
  }),
  methods: {
    submit (answer) {
      this.answered = true
    }
  }
}
</script>
